import Vue from "vue";
const view = Vue.extend({ render: h => h("router-view") });

// 钻石商城列表（邀请有奖）
const diamondStore = () => import("@/views/diamondStore/index.vue");

export default {
  path: "/diamond-store",
  component: view,
  children: [
    {
      path: "index",
      component: diamondStore
    }
  ]
};
